import type { ReactElement } from 'react';

import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';

const Component = ({ className }: { className: string }): ReactElement => {
	const theme = useTheme();

	return (
		<div className={className}>
			<svg viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.753 4.224A.832.832 0 00.554 5.376L3.077 8 9.41 1.779A.835.835 0 008.244.584L3.077 5.6 1.753 4.224z"
					fill={theme.chat.icons.messageDeliveredIcon.fill}
				/>
			</svg>
		</div>
	);
};

const MessageDeliveredIcon = styled(Component)(
	({
		theme: {
			chat: {
				icons: {
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					messageDeliveredIcon: { size, ...others },
				},
			},
		},
	}: {
		theme: Theme;
	}) => ({
		width: size,
		height: size,
		marginLeft: '5px',
		position: 'relative',
		...others,
		'& svg': {
			bottom: '-1px',
			position: 'absolute',
			left: '0',
		},
	})
);

export { MessageDeliveredIcon };
